import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PageContent, SubheaderTitle } from 'components/page_elements';
import { ConnectForm } from './connect_form';
const pageContainerCss = "p1sz2gil";
const PageContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(pageContainerCss, props.className)} />;
});
export const IcloudConnect = () => <>
    <SubheaderTitle>{I18n.t('publisher.calendar_settings.icloud.subheader')}</SubheaderTitle>
    <PageContent newAdminIALayout>
      <PageContainer>
        <ConnectForm />
      </PageContainer>
    </PageContent>
  </>;

require("./icloud_connect.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./icloud_connect.js");